import { Colors, Constants } from '@utils/css-variables'
import { makeClasses } from '@utils/styles'
import { RadioList, RequestInputs } from '@utils/request'
import Breakpoints from '@utils/breakpoints'

export type AddressInfoSectionProps = {
	form?: string
	label?: string
	errors?: string[]
	inputs?: RequestInputs[]
	isConcernedInfosRequired: boolean
	subStep?: string
	requiredFields?: string[]
	addressOptions?: RadioList[]
	fieldsAlternativeLabel?: any
	displayAddressDetails?: boolean
	showButtonUserLocation?: boolean
	isSummaryStep?: boolean
	onFixError?: React.Dispatch<React.SetStateAction<string[]>>
	onSetInputs?: (inputs: RequestInputs[]) => void
	onGetCadastralAndMatriculeNumber?: (adresse: string) => void
}

type Classes = {
	addressVoiePublicSection: string
	container: string
	button: string
	h3: string
	label: string
	formInput: string
	searchAddressDisabled: string
	map: string
	formLabel: string
	labelError: string
	required: string
	field: string
	fieldsContainerFirst: string
	fieldsContainer: string
	fieldsContainerWithLocal: string
	fieldsContainerAdditional: string
	fieldsContainerAdditionalWithLocal: string
	labelLotNumber: string
	lotNumberInput: string
	helpText: string
	radioStyle: string
	inputGroup: string
	closeIcon: string
	reducedMarginBottom: string
	answerURB: string
}

export const classes: Classes = makeClasses({
	addressVoiePublicSection: {
		padding: '25px',
		border: `1px solid ${Colors.grey}`
	},
	container: {
		// background: '#eee',
		// padding: '10px',
		// paddingBottom: '0px',
		marginTop: '10px',
		padding: '5px'
	},
	button: {
		display: 'inline-block',
		padding: '10px 20px',
		fontSize: '13px',
		fontWeight: '500',
		color: Colors.white,
		lineHeight: '1em',
		borderRadius: '23px',
		transition: 'all 0.35s ease',
		MsTransition: 'all 0.35s ease',
		background: Colors.secondary,
		border: 'none',
		cursor: 'pointer',
		'&:hover': {
			background: Colors.darkBlue2,
			borderColor: Colors.darkBlue2,
			color: Colors.white
		}
	},
	h3: {
		color: Colors.primary,
		marginTop: 0,
		marginBottom: '25px'
	},
	label: {
		margin: '5px 0px',
		':first-child': {
			marginTop: '0px'
		},
		'& span': {
			display: 'block',
			margin: '10px 0px 20px',
			lineHeight: '24px'
		}
	},
	labelError: {
		color: Colors.errorRed,
		marginBottom: '12px'
	},
	formInput: {
		fontFamily: Constants.fontStack,
		fontSize: '16px',

		background: Colors.white,
		border: `1px solid ${Colors.grey}`,
		fontWeight: 400 as any,
		padding: '12px',
		borderRadius: '0px',
		lineHeight: '26px',
		marginBottom: '10px',
		'&:focus': {
			outline: 'none'
		},
		height: '46px'
	},
	searchAddressDisabled: {
		background: Colors.lightGrey4
	},
	map: {
		margin: '-18px 0px 0px',
		':focus': {
			border: `1px solid ${Colors.primary}`
		}
	},
	formLabel: {
		margin: '0px',
		paddingBottom: 0,
		fontSize: '16px',
		fontWeight: 'bold' as any,
		display: 'block'
	},
	required: {
		':after': {
			content: '"*"',
			marginLeft: '5px',
			color: Colors.ligthPurple
		}
	},
	field: {
		'& > div': {
			padding: '0px'
		},
		'& .notification': {
			marginBottom: '20px !important',
			marginTop: '-24px'
		},
		'& .soleField input': {
			width: '100% !important',
			padding: 'none'
		}
	},
	fieldsContainerFirst: {
		'& span': {
			fontWeight: 'bold'
		}
	},
	fieldsContainer: {
		display: 'grid',
		columnGap: '20px',
		rowGap: '20px',
		gridTemplateColumns: '23% 41% 23% 6%',
		alignItems: 'center',
		[Breakpoints.maxWidth('md')]: {
			columnGap: '20px',
			gridTemplateColumns: '23% 41% 23% 6%'
			// '& >span:first-child': {
			// 	display: 'none'
			// }
		}
	},
	fieldsContainerWithLocal: {
		display: 'grid',
		columnGap: '20px',
		rowGap: '10px',
		gridTemplateColumns: '18% 34% 18% 16% 3%',
		alignItems: 'center',
		[Breakpoints.maxWidth('md')]: {
			columnGap: '8px',
			gridTemplateColumns: '19% 36% 19% 15% 5%'
			// '& >span:first-child': {
			// 	display: 'none'
			// }
		}
	},
	fieldsContainerAdditional: {
		display: 'grid',
		columnGap: '17px',
		rowGap: '10px',
		gridTemplateColumns: '23% 67% 6%',
		'& div': {
			marginBottom: '0px',
			'& label span': {
				display: 'none'
			}
		},
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '23% 67% 6%'
			// '& >span:first-child': {
			// 	display: 'none'
			// }
		}
		// [Breakpoints.maxWidth('sm')]: {
		// 	gridTemplateColumns: '90% 6%'
		// }
	},
	fieldsContainerAdditionalWithLocal: {
		display: 'grid',
		columnGap: '20px',
		rowGap: '10px',
		gridTemplateColumns: '18% 74% 6%',
		'& div': {
			marginBottom: '0px',
			'& label span': {
				display: 'none'
			}
		},
		[Breakpoints.maxWidth('md')]: {
			gridTemplateColumns: '19% 73% 6%',
			columnGap: '10px'
			// '& >span:first-child': {
			// 	display: 'none'
			// }
		}
		// [Breakpoints.maxWidth('sm')]: {
		// 	gridTemplateColumns: '19% 74% 6%',
		// 	columnGap: '8px',
		// }
	},
	labelLotNumber: {
		padding: '10px 0px'
	},
	lotNumberInput: {
		[Breakpoints.minWidth('md')]: {
			display: 'none'
		}
	},
	helpText: {
		lineHeight: '1.62em',
		color: '#999',
		fontWeight: '400',
		fontSize: '14px',
		margin: 'unset',
		position: 'relative',
		top: '-16px'
	},
	radioStyle: {
		'& div ': {
			gap: '20px'
			// marginBottom: '0px'
		}
	},
	inputGroup: {
		'& div > .soleField  ': {
			padding: '0px 0px 10px 0px',
			'box-shadow': 'none'
		}
	},
	closeIcon: {
		display: 'inline-flex',
		height: '30px',
		marginLeft: '-5px',
		cursor: 'pointer',
		marginTop: '5px',
		// alignSelf: 'flex-start',
		// marginBottom: '7px',
		img: {
			height: '100%'
		},

		'& span': {
			display: 'none'
		},

		[Breakpoints.maxWidth('sm')]: {
			marginTop: '5px',
			height: '27px',
			'& span': {
				display: 'inline',
				color: '#0054a6',
				textDecoration: 'underline',
				lineHeight: '27px'
			}
		}
	},
	reducedMarginBottom: {
		marginBottom: '0px'
	},
	answerURB: {
		display: 'block',
		margin: '0px 0px 8px',
		whiteSpace: 'normal'
	}
})

export enum AddressFieldNames {
	addressOption = 'addressOption',
	addressField = 'addressField',
	addressLotNumber = 'addressLotNumber',
	addressRegistrationNumber = 'addressRegistrationNumber',
	addressAppartment = 'addressAppartment'
}
